'use client'

import type { AnchorHTMLAttributes } from 'react'
import { trackModelShowcaseBoardClicked, type ModelShowcasePlacement } from '@/lib/analytics'

interface TrackedBoardLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'target' | 'rel'> {
  href: string
  model: string
  placement: ModelShowcasePlacement
  assetId?: string
}

/** Every link off this page goes to the public board — this is the one number the page exists to move. */
export function TrackedBoardLink({ model, placement, assetId, onClick, ...props }: TrackedBoardLinkProps) {
  return (
    <a
      {...props}
      target="_blank"
      rel="noopener noreferrer"
      onClick={event => {
        trackModelShowcaseBoardClicked({ model, placement, assetId })
        onClick?.(event)
      }}
    />
  )
}
